import { useState } from 'react';
import { size } from '@/constants/page';

export default () => {
  // 当前点击的收藏夹的目录
  const [collectDir, setCollectDir] = useState('');
  const [collectData, setCollectData] = useState<string[]>([]);
  const [favoriteList, setFavoriteList] = useState<any>(
    Array.from({ length: size }, (_, index) => ({ id: index + 1, mock: true })),
  );
  const [materialInfo, setMaterialInfo] = useState<object | null>(null);
  const [activeModal, setActiveModal] = useState(null);
  // 定义状态
  const [favoritesCollect, setFavoritesCollect] = useState<string[]>([]);
  const [unfavoritesCollect, setUnfavoritesCollect] = useState<string[]>([]);

  // 设置收藏的函数
  const toggleFavorite = (id: string) => {
    setFavoritesCollect((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );

    // 如果该 ID 在取消收藏集合中，则移除
    setUnfavoritesCollect((prev) => prev.filter((item) => item !== id));
  };

  // 设置取消收藏的函数
  const toggleUnfavorite = (id: string) => {
    setUnfavoritesCollect((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );

    // 如果该 ID 在收藏集合中，则移除
    setFavoritesCollect((prev) => prev.filter((item) => item !== id));
  };

  // 重置状态的函数
  const resetCollectStates = () => {
    setFavoritesCollect([]);
    setUnfavoritesCollect([]);
  };
  interface CategoryManager {
    show?: boolean;
    dragId?: string;
    oldCategoryId?: string;
    type?: string;
    item?: any;
    id?: string;
  }
  const [showCategoryManager, setShowCategoryManager] =
    useState<CategoryManager>({});

  return {
    collectDir,
    setCollectDir,
    collectData,
    setCollectData,
    favoriteList,
    setFavoriteList,
    materialInfo,
    setMaterialInfo,
    activeModal,
    setActiveModal,
    toggleFavorite,
    toggleUnfavorite,
    resetCollectStates,
    favoritesCollect,
    unfavoritesCollect,
    showCategoryManager,
    setShowCategoryManager,
  };
};
